interface PixelAnalytics {
  proxy: {
    fbq: (operationType: string, eventName: string, eventData?: object) => void;
  };
}

export const loadMetaPixel = (id: string): PixelAnalytics =>
  <PixelAnalytics>(<unknown>useScriptMetaPixel({ id }));
